import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { forwardRef } from "react";

interface propsType {
  privateMessageList: any[]
}

const ChatPrivate = ({ privateMessageList } : propsType) => {
  return (
    <Box sx={{ width: "100%" }}>
      {privateMessageList.map((message: any, index) => (
        <Box key={index} sx={{ 
          py: 0.5, 
          display: "flex",
          justifyContent: message.Type === "PRIVATE" ? "flex-end" : "flex-start"}}>
          <Stack direction="column" spacing={0} sx={{ maxWidth: "250px", boxSizing: "border-box"}}>
            <Box sx={{ display: "flex",
              px: 1,
              py: 0.5,
              justifyContent: message.Type === "PRIVATE" ? "flex-end" : "flex-start"
            }}>
              <Box sx={{ backgroundColor: message.Type === "PRIVATE" ? "#024d5e" : "#2e2f34",
                borderRadius: "1rem",
                p: 1.5,
                boxSizing: "border-box"
              }}>
                <Typography sx={{ color: "#fff", wordBreak: "break-word" }}>{message.Content}</Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", px: 1.5, justifyContent: message.Type === "PRIVATE" ? "flex-end" : "flex-start"}}>
              <Typography sx={{ fontSize: "9px"}}>{dayjs(message.CreatedTimestamp).format("MM-DD HH:mm:ss")} </Typography>
            </Box>
          </Stack>
        </Box>))}
    </Box>
  );
}


export default ChatPrivate;